import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { colors } from '@nerdwallet/base-styles/variables';
import styles from './_star.module.less'; // TODO: Consider refactoring this back into StarRating

var Star = function Star(_ref) {
  var className = _ref.className,
      firstHalfStarFill = _ref.firstHalfStarFill,
      secondHalfStarFill = _ref.secondHalfStarFill;
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 14 14",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    className: classNames(className, styles.star),
    role: "img",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "outline_selected"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00aacc",
    result: "base"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    result: "bigger",
    "in": "SourceGraphic",
    operator: "dilate",
    radius: "1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "mask",
    "in": "bigger",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "drop",
    "in": "base",
    in2: "mask",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    "in": "drop",
    stdDeviation: "1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "blur",
    mode: "normal"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd",
    className: styles['inner-group']
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: firstHalfStarFill,
    transform: "translate(3.501500, 6.650000) translate(-3.501500, -6.650000) ",
    points: "6.996 0 5.03 4.63725674 0 5.0730929 3.813 8.38284867 2.674 13.3000002 7.001 10.6979784 7.003 10.6999776"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: secondHalfStarFill,
    transform: "translate(10.470000, 6.650000) scale(-1, 1) translate(-10.490000, -6.650000)",
    points: "13.9830028 -1.0658141e-14 12.017845 4.63725674 6.98999977 5.0730929 10.8013663 8.38284867 9.66285426 13.3000002 13.9880006 10.6979784 13.9899998 10.6999776"
  })));
};

Star.displayName = 'Star';
Star.propTypes = {
  className: PropTypes.string,
  firstHalfStarFill: PropTypes.string,
  secondHalfStarFill: PropTypes.string
};
Star.defaultProps = {
  className: null,
  firstHalfStarFill: colors['neutral-darker'],
  secondHalfStarFill: colors['neutral-darker']
};
export default Star;